import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function SalesFunnel(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "SalesFunnel", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.75 9H8.25c-.39782 0-.77936-.15804-1.06066-.43934C6.90804 8.27936 6.75 7.89782 6.75 7.5c0-.39782.15804-.77936.43934-1.06066C7.47064 6.15804 7.85218 6 8.25 6h31.5c.3978 0 .7794.15804 1.0607.43934S41.25 7.10218 41.25 7.5c0 .39782-.158.77936-.4393 1.06066C40.5294 8.84196 40.1478 9 39.75 9Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M38.25 9 28.5 22.5v5.25l-9 1.5V22.5L9.75 9h28.5Z", fill: theme.vars.palette.primary.light }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 45c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24 37.1546c-.2652 0-.5196-.0891-.7071-.2477-.1875-.1585-.2929-.3736-.2929-.5978s.1054-.4393.2929-.5978c.1875-.1586.4419-.2476.7071-.2476h2c.2652 0 .5196-.0891.7071-.2477.1875-.1585.2929-.3736.2929-.5978s-.1054-.4393-.2929-.5978c-.1875-.1586-.4419-.2476-.7071-.2476h-1c-.0118-.1111-.0494-.219-.1106-.3178-.0611-.0987-.1447-.1863-.2459-.2578-.1012-.0714-.2181-.1253-.344-.1585-.1258-.0333-.2582-.0453-.3895-.0353-.1313.01-.259.0418-.3758.0935-.1168.0517-.2204.1224-.3049.2079-.0845.0856-.1483.1844-.1876.2908-.0394.1064-.0535.2183-.0417.3294-.6614.2028-1.2174.5958-1.5708 1.1101-.3534.5144-.4817 1.1174-.3626 1.7036.1191.5862.4782 1.1184 1.0144 1.5035s1.2155.5986 1.919.6032c.2652 0 .5196.0891.7071.2477.1875.1585.2929.3736.2929.5978s-.1054.4393-.2929.5978c-.1875.1586-.4419.2476-.7071.2476h-2c-.2652 0-.5196.0891-.7071.2477-.1875.1585-.2929.3736-.2929.5978s.1054.4393.2929.5978c.1875.1586.4419.2476.7071.2476h1c.0118.1111.0494.219.1106.3178.0611.0987.1447.1863.2459.2578.1012.0714.2181.1253.344.1585.1258.0333.2582.0453.3895.0353.1313-.01.259-.0418.3758-.0935.1168-.0517.2204-.1224.3049-.2079.0845-.0856.1483-.1844.1876-.2908.0394-.1064.0535-.2183.0417-.3294.6614-.2028 1.2174-.5958 1.5708-1.1101.3534-.5144.4817-1.1174.3626-1.7036-.1191-.5862-.4782-1.1184-1.0144-1.5035s-1.2155-.5986-1.919-.6032Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 34v4.5m0 0L10.5 37m1.5 1.5 1.5-1.5M9 21.25v4.5m0 0-1.5-1.5m1.5 1.5 1.5-1.5m28.5-7.5v4.5m0 0-1.5-1.5m1.5 1.5 1.5-1.5M36 29.5V34m0 0-1.5-1.5M36 34l1.5-1.5",
        fill: theme.vars.palette.primary.light
      }
    )
  ] });
}
SalesFunnel.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "SalesFunnel"
};
validateTidalLicense();
export {
  SalesFunnel
};
//# sourceMappingURL=SalesFunnel.js.map
